module.exports = __webpack_public_path__ + "img/children-boots.099a98f8.webp";